import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e4825bec"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4825bec')) {
      api.createRecord('e4825bec', component.options)
    } else {
      api.reload('e4825bec', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e4825bec", function () {
      api.rerender('e4825bec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/social/index.vue"
export default component.exports